import React from 'react'
import * as moment from 'moment'
import { useDispatch } from 'react-redux'
import { changeCompanyModal, setActiveMemberId } from '../../../../../../../redux/actions/company'
import { auth } from '../../../../../../../networking/firebase'
import { ChangeIconButton, DeleteIconButton, InfoTableButton } from '../../../../../../library/button'

const Index = ({member, index, arr }) => {

    const dispatch = useDispatch()

    const format_role = role => {
        switch(role){
            case "administrator":
                return "Administrator"
            case "standard":
                return "Standard"
            default:
                return "Standard"
        }
    }
    
    const clickEditMember = (id, role) => {
        /*
        dispatch(setActiveMemberId({id: id, role: role}))
        dispatch(changeCompanyModal({changeRole: true}))
        */
    }

    const clickDeleteMember = id => {
        /*
        dispatch(setActiveMemberId({id: id}))
        dispatch(changeCompanyModal({removeMember: true}))
        */
    }

    return(
        <tr className={index === (arr.length - 1) && "last"}>
            <td><span className="name">{member && member.name}</span></td>
            <td>{moment.unix(member.timestamp).format('HH:MM DD/MM/YYYY')}</td>
            <td><InfoTableButton title={format_role(member && member.role)} color='blue'/></td>
            <td><ChangeIconButton onClick={() => clickEditMember(member && member.id, member && member.role)}/><DeleteIconButton className={`${member.id === auth.currentUser.uid ? 'disabled':''}`} data-tip={`${member.id === auth.currentUser.uid ? 'Du kan ikke slette deg selv.':''}`} disabled={member.id === auth.currentUser.uid ? true:false} onClick={() => clickDeleteMember(member && member.id)}/></td>
        </tr>
    )
}

export default Index

